import { WsBaseRequest } from 'api/ws/WsRequest';
import { API_UPDATE_AVATAR } from 'api/notificationManager/methods';

export default class UpdateAvatarsRequest extends WsBaseRequest {
  constructor(data: any) {
    super(API_UPDATE_AVATAR, data);
  }
}
